import APIs from '../common/APIs'
import defaultRestApi from '../common/RestApiInstance'
import querystring from 'query-string'

export default class LiveCenterServices {

  static getAllLiveCenterEvents = (liveCenterSeverPath, params = {all: true}) => {
    return defaultRestApi.get(APIs.getAllLiveCenterEventsURL(liveCenterSeverPath, querystring.stringify(params)));
  }
  static getAllLiveTVEvents = (liveCenterSeverPath, params) => {
    return defaultRestApi.get(APIs.getAllLiveTVEventsURL(liveCenterSeverPath, params));
  }

  static getAllEventLivenCenter = (params = {all: true}) => {
    return defaultRestApi.get(APIs.getAllEventLivenCenter(querystring.stringify(params)));
  }
}


// WEBPACK FOOTER //
// ./src/app/services/LiveCenterServices.js